import type { RefObject } from 'react';
import React, { memo } from 'react';

import { Box } from '@mui/material';

import type { TabSymbol } from '@/features/Dashboard/context/EditChartApp';

import { SortableItem } from './SortableItem';

import type { SxProps } from '@mui/material';

type DroppableAreaProps = {
  id: string;
  items: TabSymbol[];
  sx?: SxProps;
  baseIndex?: number;
  container: RefObject<HTMLDivElement | null>;
};

const DroppableAreaComponent: React.FC<DroppableAreaProps> = ({
  id,
  items,
  sx = {},
  baseIndex = 0,
  container
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 100,
        ...sx
      }}
    >
      {items.map((item, index) => (
        <SortableItem
          key={item.id}
          container={container}
          item={item}
          itemIndex={index + baseIndex}
          sourceListId={id}
        />
      ))}
    </Box>
  );
};

export const DroppableArea = memo(DroppableAreaComponent);
